import { Separator } from "@chakra-ui/react"
import Figure from "@hydrologiq/shared/figures/generic/Figure"
import { roundToDP } from "@hydrologiq/common/helpers/math"
import FigureContent from "@hydrologiq/shared/figures/generic/FigureContent"

export interface ComparisonProps {
  period: string
  quantity: number
  previousQuantity: number
  description: string
  unit: string
  error?: string
  loading?: boolean
  title?: string
}

function Comparison({
  period,
  quantity,
  previousQuantity,
  description,
  unit,
  error,
  loading = false,
  title,
}: ComparisonProps) {
  quantity = roundToDP(quantity, 2)
  previousQuantity = roundToDP(previousQuantity, 2)

  return (
    <Figure heading={title ?? "Comparison"} error={error} loading={loading}>
      <FigureContent.Root>
        <FigureContent.SubText>{period}</FigureContent.SubText>
        <FigureContent.Value>
          {quantity} {unit}
        </FigureContent.Value>
      </FigureContent.Root>

      <Separator mb={1} />
      <FigureContent.Label>
        {previousQuantity} {unit} {description}
      </FigureContent.Label>
    </Figure>
  )
}

export default Comparison
